export default "__VITE_ASSET__$uz623w4__"